import { render, staticRenderFns } from "./AccountCorporateTable.vue?vue&type=template&id=1689bd15&lang=pug"
import script from "./AccountCorporateTable.vue?vue&type=script&lang=js"
export * from "./AccountCorporateTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports